import React from 'react'

function FileVideo() {
    return (
        <>暂无数据！</>
    )
}

export default FileVideo
